@if (naytettavaKirjausObservable | async; as valittuKirjaus) {
  @if (naytettavatTositteetJaSivutObservable | async; as naytettavatTositteetJaSivut) {
    <div style="display: flex; height: calc(100vh - 40px); flex-direction: column; flex-grow: 1" [class.sivuja]="naytettavatTositteetJaSivut.length">
      <div #mainDiv class="tositteet-container">
        <div app-kirjanpito-tilintarkastus-tosite-naytto [isMainEnhancedOn]="isMainEnhancedOn" [naytettavatTositteetJaSivut]="naytettavatTositteetJaSivut" [scrollContainerRef]="mainDivRef" [naytettavaKirjausObservable]="naytettavaKirjausObservable"></div>
      </div>
    </div>
  } @else {
    <div class="kirjauksen-tositteet-ladataan-metadataa">
      <div style="margin-bottom: 1em">Ladataan kirjaukseen liitettyjen tositteiden tietoja</div>
      <mat-progress-bar mode="indeterminate" style="margin: 20px 0; width: calc(100% - 40px)"></mat-progress-bar>
    </div>
  }
} @else {
  <div class="kirjauksen-tositteet-ei-valittua">
    <div><span class="virhe-teksti">Virhe!&nbsp;</span>Valitse kirjaus</div>
  </div>
}
